import React, { useState } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import { userApi } from '../api/apiService';
import TaskNotification from './TaskNotification';
import SubscriptionPolicyWarning from './SubscriptionPolicyWarning';

const { Option } = Select;

const AccountForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [taskId, setTaskId] = useState(null);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      setError(null);
      
      // Ensure platform is set to pingme as default
      const accountData = {
        ...values,
        platform: values.platform || 'pingme'
      };
      
      console.log('Creating account with data:', accountData);
      
      const response = await userApi.createAccount(accountData);
      console.log('Success response:', response);
      
      if (response && response.account) {
        message.success('Account added successfully');
        
        // Check if a background task was started and set task ID
        if (response.account.subscription_task_id) {
          setTaskId(response.account.subscription_task_id);
        }
        
        // Make sure we're calling onSuccess with the account data
        if (onSuccess) {
          console.log('Calling onSuccess with account data:', response.account);
          onSuccess(response.account);
        }
      } else {
        console.error('Invalid response format:', response);
        message.warning('Account may have been added but response format was unexpected');
      }
    } catch (error) {
      console.error('Error creating account:', error);
      
      // More detailed error handling
      let errorMsg = 'Failed to add account';
      if (error.response && error.response.data) {
        if (error.response.data.error) {
          errorMsg = error.response.data.error;
        } else {
          errorMsg = JSON.stringify(error.response.data);
        }
      }
      message.error(errorMsg);
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Handle task completion
  const handleTaskComplete = (result) => {
    // You can show a specific message when the subscription task completes
    if (result && result.success_count > 0) {
      message.success(`成功订阅了 ${result.success_count} 个号码!`);
    }
    
    // If any numbers failed to subscribe due to insufficient balance
    if (result && result.failed_count > 0) {
      // Check if any error is due to insufficient balance
      const insufficientBalance = result.errors && result.errors.some(
        error => error.error && error.error.includes("Insufficient balance")
      );
      
      if (insufficientBalance) {
        message.warning('部分号码因余额不足未能订阅，请充值后再试。');
      }
    }
  };

  return (
    <div>
      {/* Show subscription policy warning */}
      <SubscriptionPolicyWarning />
      
      {/* Show task notification if there's an active task */}
      {taskId && (
        <TaskNotification
          taskId={taskId}
          title="订阅账号号码"
          onComplete={handleTaskComplete}
        />
      )}
      
      <Form
        name="accountForm"
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ platform: 'pingme' }} // Default to pingme
      >
        <Form.Item
          name="platform"
          label="平台"
          rules={[{ required: true, message: '请选择一个平台' }]}
        >
          <Select defaultValue="pingme">
            <Option value="pingme">PingMe</Option>
            <Option value="wephone">WePhone</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="email"
          label="电子邮箱"
        >
          <Input placeholder="account@example.com" />
        </Form.Item>

        <Form.Item
          name="phone"
          label="电话号码"
          extra="请包含国家代码（例如：+1234567890）"
        >
          <Input placeholder="+1234567890" />
        </Form.Item>

        {error && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            错误: {error}
          </div>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            添加账户
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AccountForm; 